import type {QuickOrderSalesOptions, QuickOrderSuggestiveSellingTarget} from '../types';

export interface CreateQuickOrderTargetParams {
    customerId?: number;
    defaultWarehouseCode?: string;
    getDraftItems: QuickOrderSuggestiveSellingTarget['getDraftItems'];
    onDraftItemAdded: QuickOrderSuggestiveSellingTarget['onDraftItemAdded'];
    salesOptions: QuickOrderSalesOptions;
}

export function createQuickOrderTarget(params: CreateQuickOrderTargetParams): QuickOrderSuggestiveSellingTarget {
    return {
        type: 'quickOrder',
        customerId: params.customerId,
        defaultWarehouseCode: params.defaultWarehouseCode,
        getDraftItems: params.getDraftItems,
        onDraftItemAdded: params.onDraftItemAdded,
        salesOptions: params.salesOptions,
    };
}
